export const BACKEND_EXPECTED_OPERATION = "set_item_display_property_display_name_override";
export const ITEM_DISPLAY_PROPERTY_KEY = "item_display_property";
